/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from "react";
// javascipt plugin for creating charts
import Chart from "chart.js";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Col,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Table,
  Container,
  Row,
  Button,
  Dropdown,
  Badge,
  Progress,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Spinner
} from "reactstrap";

// core components
import {
  chartOptions,
  parseOptions,
} from "dashboard/general-management/variables/charts.js";
import { api } from "../../../../api";
import Cookies from "js-cookie";

const Budget1 = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const emp_id = Cookies.get("token");

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  const [project, setproject] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        if (!company_id || !emp_id) {
          throw new Error('Missing company_id or emp_id in cookies');
        }
        const response = await api.get(
          `viewProjectDetails.php?g_m_id=${emp_id}&company_id=${company_id}`
        );
        setproject(response.data);
        const response2 = await api.get(
          `materailsCountdeatils.php?emp_id=${emp_id}&company_id=${company_id}`
        );
        setbudget(response2.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [emp_id]);

  const [selectedproject, setselectedproject] = useState();

  const [budget, setbudget] = useState({ details: [] });
  const handleProjectSelection = async (p_id, p_name) => {
    setselectedproject(p_name);
    try {
      const company_id = Cookies.get('company_id');
      if (p_id === "all") {
        const response = await api.get(
          `materailsCountdeatils.php?emp_id=${emp_id}&company_id=${company_id}`
        );
        console.log("API Response:", response.data);
        setbudget(response.data);
        console.log(response);
      } else {
        const response = await api.get(
          `materailsCountdeatils.php?p_id=${p_id}&company_id=${company_id}`
        );
        console.log("API Response:", response.data);
        setbudget(response.data);
        console.log(response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-5 ">
        <div className="bg-gradient-info pb-8 pt-2 pt-md-8">
          <Container fluid>
            <div className="header-body">
              <div className="justify-content-end ">
                <Dropdown
                  isOpen={dropdownOpen}
                  toggle={toggleDropdown}
                  className="mb-4 justify-content-end "
                >
                  <DropdownToggle caret>
                    {selectedproject && selectedproject
                      ? selectedproject
                      : "All Projects"}
                  </DropdownToggle>
                  <DropdownMenu left>
                    <DropdownItem
                      onClick={() =>
                        handleProjectSelection("all", "All Projects")
                      }
                    >
                      All Projects
                    </DropdownItem>
                    {project.map((project) => (
                      <DropdownItem
                        key={project.p_id}
                        onClick={() =>
                          handleProjectSelection(project.p_id, project.p_name)
                        }
                      >
                        {project.p_name}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
                <span>Select project to view budget details</span>
              </div>
              <Row>
              <Col lg="6" xl="4">
                <Card className="card-stats mb-4 mb-xl-3" style={{ borderRadius: '15px',boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff' }}>
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center">
                      <CardTitle tag="h5" className="mb-0">Total Budget</CardTitle>
                      <span className="h2 font-weight-bold mb-0">{budget.p_budget}</span>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="4">
    <Card className="card-stats mb-4 mb-xl-0" style={{ borderRadius: '15px',boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff' }}>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle tag="h5" className="mb-0">Drained Amount</CardTitle>
          <span className="h2 font-weight-bold mb-0">{budget.spent}</span>
        </div>
      </CardBody>
    </Card>
  </Col>
  <Col lg="6" xl="4">
    <Card className="card-stats mb-4 mb-xl-0" style={{ borderRadius: '15px',boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff' }}>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle tag="h5" className="mb-0">Remaining Amount</CardTitle>
          <span className="h2 font-weight-bold mb-0">{budget.remaining}</span>
        </div>
      </CardBody>
    </Card>
  </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Container className="mt--7 " fluid>
          <Row className="mt-2">
            <Col className="mb-5 " xl="12">
              <Card
                className=""
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Material Details</h3>
                    </div>
                  </Row>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Material Name</th>
                      <th scope="col">Amount Spent</th>
                      <th scope="col">Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {budget.details ? (
                      budget.details.map((material, index) => (
                        <tr key={index}>
                          <td>{material.mat_name}</td>
                          <td>{material.mat_money}</td>
                          <td>{material.mat_quantity}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td center colSpan="3">
                          No details available, Project not yet started
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Budget1;
